module.exports = __webpack_public_path__ + "static/media/aq.85bf0f99.svg";